export const INVOICES_FILTERS_EXPANDED_HEIGHT = 162;
export const FILTER_BAR_HEIGHT = 35;
export const REIMBURSEMENT_FILTER_OPTIONS = [
  {
    labelKey: 'buttons.counterParties',
    value: 'false'
  },
  { labelKey: 'labels.reimbursements', value: 'true' }
];
